import { ResourceHelperService } from '../resource-helper.service';

/**
 * A dataservice that provides operations for usage events
 */
export class UsageEventService {
  private resource: InterACT.Interfaces.IResource<InterACT.Interfaces.UsageEvents.UsageEventResponse | InterACT.Interfaces.UsageEvents.UsageEventsResponse>;

  constructor($resource: ng.resource.IResourceService, private resourceHelperService: ResourceHelperService) {
    this.resource = $resource('api/usage-events/:usageEventId');
  }

  /**
 * Retrieves a single usage event using the supplied id
 * @param id the id of the usage event to retrieve
 * @return a promise that resolves with the usage event when the operation is complete
 */
  public get(id: string): ng.IPromise<InterACT.Interfaces.UsageEvents.UsageEventResponse> {
    return <ng.IPromise<InterACT.Interfaces.UsageEvents.UsageEventResponse>>this.resource.get({ usageEventId: id }).$promise;
  }

  /**
   * A method that returns a number of usage events for a given page and query
   * @param page the page number to retrieve
   * @param perPage the maximum number of usage events to retrieve
   * @param query the query to use to filter the usage events
   */
  public getList(page: number, perPage: number, query: string): ng.IPromise<InterACT.Interfaces.UsageEvents.UsageEventsResponse> {
    const requestOptions = this.resourceHelperService.buildRequestOptions(page, perPage, query);
    return <ng.IPromise<InterACT.Interfaces.UsageEvents.UsageEventsResponse>>this.resource.get(requestOptions).$promise;
  }
}
